const TiktokIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icons8-tiktok 1'>
      <path
        id='Vector'
        d='M20.0134 1.91992H4.65342C3.33006 1.91992 2.25342 2.99656 2.25342 4.31992V19.6799C2.25342 21.0033 3.33006 22.0799 4.65342 22.0799H20.0134C21.3368 22.0799 22.4134 21.0033 22.4134 19.6799V4.31992C22.4134 2.99656 21.3368 1.91992 20.0134 1.91992ZM18.0963 10.715C17.9873 10.725 17.8769 10.7318 17.7651 10.7318C16.5061 10.7318 15.3997 10.0842 14.756 9.10552C14.756 11.673 14.756 14.5943 14.756 14.6433C14.756 16.9036 12.9233 18.7362 10.663 18.7362C8.4027 18.7362 6.57006 16.9036 6.57006 14.6433C6.57006 12.383 8.4027 10.5503 10.663 10.5503C10.7485 10.5503 10.832 10.558 10.916 10.5633V12.5802C10.832 12.5702 10.7494 12.5548 10.663 12.5548C9.5091 12.5548 8.57406 13.4898 8.57406 14.6438C8.57406 15.7977 9.5091 16.7327 10.663 16.7327C11.8169 16.7327 12.836 15.8236 12.836 14.6697C12.836 14.6241 12.8561 5.26456 12.8561 5.26456H14.7838C14.9653 6.98824 16.3568 8.34856 18.0963 8.47336V10.715Z'
        fill='#FAFAFA'
      />
    </g>
  </svg>
)

export default TiktokIcon
